import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { FilesApiService } from 'src/app/core/services/api/files-api.service';
import { CaseSubject } from '../../models/cases/caseSubject';

@Component({
  selector: 'app-case-subject-create-edit',
  templateUrl: './case-subject-create-edit.component.html',
  styleUrls: ['./case-subject-create-edit.component.scss']
})
export class CaseSubjectCreateEditComponent implements OnInit {

  public caseSubject: CaseSubject;

  @ViewChild('caseSubjectsModal') caseSubjectsModal;
  @Output() submit: EventEmitter<CaseSubject> = new EventEmitter<CaseSubject>();

  modalRef: NgbModalRef;

  constructor(private modalService: NgbModal,
    private api: FilesApiService,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
  }

  // handle the popup
  open(caseSubject: CaseSubject) {
    this.caseSubject = Object.assign(new CaseSubject(), caseSubject);
    this.modalRef = this.modalService.open(this.caseSubjectsModal, { centered: true, size: 'lg' });
  }

  close() {
    this.modalRef.close();
  }

  onSubmit() {
    if (this.caseSubject.id) {
      this.spinner.show();
      this.api.updateCaseSubject(this.caseSubject).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
        }
      )
    } else {
      this.spinner.show();
      this.api.createCaseSubject(this.caseSubject).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
        }
      )
    }
  }

}
